export default __webpack_public_path__ + "static/media/Grass.86a27274.png";